module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/174-denmark-161d640332f954a970f2360e6fe06a53.svg";